import React, { useState } from 'react';
import UserMenu from './UserMenu';
import { Tooltip } from 'antd';
import { IconTrashX } from '@tabler/icons-react';
// import ModalHistoriBarangTerhapus from './ModalHistoriBarangTerhapus';

function Header({ sidebarOpen, setSidebarOpen, title, openModal, compFilter, dateFilter }) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  function closeModal() {
    setIsOpenModal(false);
  }
  return (
    <header className="sticky top-0 bg-gradient-to-r from-yellow-200/90 via-amber-100/90 to-yellow-200/90 dark:from-amber-900/40 dark:via-slate-900 dark:to-amber-900/40 backdrop-blur-md border-b border-amber-300/60 dark:border-amber-700/50 z-10 transition-colors duration-300 shadow-sm">
      {/* <ModalHistoriBarangTerhapus isOpen={isOpenModal} closeModal={closeModal} /> */}
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 -mb-px">
          {/* Header: Left side */}
          <h1 className="hidden whitespace-nowrap lg:block -ml-3 text-xl font-bold mt-3 text-black dark:text-white">{title}</h1>
          <div className="flex justify-between items-center w-full">
            <div className="flex items-center gap-3">
              {/* Hamburger button */}
              <button
                className="text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
                aria-controls="sidebar"
                aria-expanded={sidebarOpen}
                onClick={(e) => {
                  e.stopPropagation();
                  setSidebarOpen(!sidebarOpen);
                }}
              >
                <span className="sr-only">Open sidebar</span>
                <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <rect x="4" y="5" width="16" height="2" rx="1" />
                  <rect x="4" y="11" width="16" height="2" rx="1" />
                  <rect x="4" y="17" width="16" height="2" rx="1" />
                </svg>
              </button>

              <p className="font-semibold text-sm text-slate-900 dark:text-slate-300 md:block hidden">
                {dateFilter === 'Invalid date' ? '' : <span className="text-sm "> {dateFilter}</span>}
              </p>
            </div>
            <div>{compFilter}</div>
          </div>

          {/* Header: Right side */}
          <div className="md:flex items-center hidden">
            <hr className="w-px h-6 bg-slate-200 dark:bg-slate-700 mx-3" />
            {/* <Tooltip title="Histori Barang">
              <button onClick={() => setIsOpenModal(true)} className="bg-slate-300 rounded-md p-1.5">
                <IconTrashX />
              </button>
            </Tooltip> */}
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
